<template>
    <div class="site__body-order-entry">
        <div class="block-header block-header--has-breadcrumb block-header--has-title">
            <div class="container">
                <div class="block-header__body">
                    <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb--and-title-only" aria-label="breadcrumb">
                        <ol class="breadcrumb__list">
                            <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                            <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                <router-link to="/" class="breadcrumb__item-link">Home</router-link>
                            </li>
                            <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item" aria-current="page">
                                <router-link to="/order-parts" class="breadcrumb__item-link">Order Parts</router-link>
                            </li>
                            <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page">
                                <span class="breadcrumb__item-link">Stock Order Entry</span>
                            </li>
                            <li class="breadcrumb__title-safe-area" role="presentation"></li>
                        </ol>
                    </nav>
                    <h1 class="block-header__title">Stock Order Entry</h1>
                </div>
        </div>
        <div class="block">
            <div class="container">
                <div>
                    <functions 
                        @csvUploaded="csvUpload" 
                        @validate_parts="validate_parts" 
                        @remove_invalid="remove_invalid"
                        @add_to_cart="add_to_cart"
                        :hasValidated="hasValidated" :allValid="allValid"
                        :needValidateParts="needValidateParts"
                        >
                    </functions>
                    <stock-order-list :mparts="parts" :locations="locations" 
                        @add_to_cart="add_to_cart" :allValid="allValid"
                        @remove_item="remove_item"
                        @update_qty="update_qty"
                        @update_item_code="changeItemCode"
                        @update_mfg_code="changeMFGCode"
                        >
                    </stock-order-list>
                </div>						
                <div>                            
                </div>
            </div>
            </div>
        </div>
        <div class="block-space block-space--layout--divider-order-entry"></div>
    </div>			
    <div class="block-space block-space--layout--divider-thin"></div>
    <div class="block-space block-space--layout--divider-thin"></div>
</template>

<script>
import Functions from './Functions';
import StockOrderList from './StockOrderList';
import axiosvl from "../../../axios/axios-vl.js";


export default {
    components: {
        Functions,
        StockOrderList
    },
    data() {
        return {
            parts: [],
            locations: [],
            minRow : 12,

            servermessages: [],

            hasValidated: false,
            allValid: false,
            needValidateParts: false,
        };
    },
    methods: {
        part_details() {
            const rows = this.minRow;
            const MPARTS = [];
            for(let i = 1; i <= rows; i++){
                MPARTS.push({
                    item : '',
                    quantity : 0,
                    manufacturer : '',
                    isValid: '',
                });
            }
            this.parts = MPARTS;
        },

        csvUpload(data){
            this.parts = [];
            data.forEach((row) => {
                this.parts.push({
                    item : row[0],
                    quantity : parseInt(row[1]),
                    manufacturer : row[2],
                    isValid: '',
                });
            });

            const rows = this.minRow - data.length;
            if (rows > 0){
                for(let i = 1; i <= rows; i++){
                    this.parts.push({});
                }
            }

            this.hasValidated = false;
            this.allValid = false;
        },

        /**
         * validate parts from the list
         */
        validate_parts() {
            this.isloading = true;
            const paramParts = [];
            
            this.parts.forEach(p => {
                if(p.item != null && p.item != ''){
                    paramParts.push([
                        p.item,
                        p.manufacturer
                    ]);
                } 
            });

            const validate_parts_uri = this.$store.getters['api/validate_parts_uri'];
            // "/d15pgmlib/lansaweb?w=CESGETCNT&r=usGetSinglePageCont&vlweb=1&part=CML&lang=ENG&_T=20210114"
            axiosvl.post(validate_parts_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                             "EHCUST": {"value": this.$store.getters.customer},
                        },
                        "lists": {
                            "PARTSOD": {
                                "header": [
                                    {"name": "EKITMC"},
                                    {"name": "EKMFGC"}
                                ],
                                "entries": paramParts
                            }
                        }
                    }
                }
            )
            .then((response) => {
                const DPLISTS = response.data.webroutine.lists.DPLISTS.entries;
                const val_parts = [];
                let hasInvalid = false;
                
                for (const key in DPLISTS) {
                    const obj = DPLISTS[key];
                    
                    if(obj.DPVALID == 'N'){
                        hasInvalid = true;
                    }

                    val_parts.push({
                        ID        : obj.IXITMC,
                        item      : obj.IXITMC,
                        desc      : obj.EPIMG1,
                        manufacturer: obj.IXMFGC,
                        isValid: obj.DPVALID,
                        quantity: this.parts.find((__,index) => {
                            const i = index + 1;
                            return (i == obj.DPLINE);
                        }).quantity,
                    });
                }
                this.parts = val_parts;

                const rows = this.minRow - val_parts.length;
                if (rows > 0){
                    for(let i = 1; i <= rows; i++){
                        this.parts.push({});
                    }
                }

                this.hasValidated = hasInvalid;
                

                if(hasInvalid == false){
                    this.allValid = true;
                }

                // console.table(val_parts);
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        },

        remove_invalid() {
            const valid_parts = [];
            this.parts.forEach(i => {
                if(i.isValid == 'Y'){
                    valid_parts.push(i);
                }
            });
            this.allValid = true;
            this.parts = valid_parts;
        },

        add_to_cart() {
            this.isloading = true;
            const paramParts = [];

            this.parts.forEach(p => {
                if(p.item != null){
                    paramParts.push([
                        p.manufacturer,
                        p.item
                    ]);
                } 
            });

            const part_details_uri = this.$store.getters['api/part_details_uri'];
            axiosvl.post(part_details_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                             "EHCUST": {"value": this.$store.getters.customer},
                        },
                        "lists": {
                            "MPARTSI": {
                                "header": [
                                    {"name": "EIMFGC"},
                                    {"name": "EIITMC"}
                                ],
                                "entries": paramParts
                            }
                        }
                    }
                }
            )
            .then((response) => {
                const MPARTS = response.data.webroutine.lists.MPARTS.entries;
                // console.table(MPARTS);
                let part = {};
                for (const key in MPARTS) {
                    const obj = MPARTS[key];
                    part = {
                        ID        : obj.EIITMC,
                        item      : obj.EIITMC,
                        desc      : obj.IMDESC,
                        manufacturer: obj.EIMFGC,
                        manufacturername: obj.MCNAME,
                        // quantity: 1,
                        // this.parts.find(i => i.item == obj.EIITMC).quantity,
                        quantity: this.parts.find(i => i.item == obj.EIITMC).quantity,
                        listprice: obj.EILSTP,
                        corecharge: obj.EICORP,
                        yourprice: obj.EIEXCP,
                        locationid: obj.CMDLOC,
                        isValid: obj.QOSTK,
                        stockquantity: obj.QTYAVL,
                        TOTOH: obj.TOTOH,
                        IMIGSA: obj.IMIGSA,
                        IMISVALID: obj.IMISVALID,
                    };

                    this.$store.dispatch("cart/addToCart", part);
                }

                setTimeout(() => {
                    this.isloading = false;   
                    
                    this.$router.push("/order-parts");
                }, 2000);

                this.allValid = false;          
            
                this.part_details();
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        },

        remove_item(index){
            this.parts.splice(index, 1);
        },

        update_qty(index, newQty){
            this.parts.filter((part, indx) => {
                if(indx == index){
                    part.quantity = newQty;
                    
                }
            });
        },
        changeItemCode(index, newVal){
            this.parts.filter((part, indx) => {
                if(indx == index){
                    part.item = newVal;
                    part.isValid = '';
                    this.needValidateParts = true;
                    this.allValid = false;
                }
            });
        },
        changeMFGCode(index, newVal){
            this.parts.filter((part, indx) => {
                if(indx == index){
                    part.manufacturer = newVal;
                    part.isValid = '';
                    this.needValidateParts = true;
                    this.allValid = false;
                }
            });
        }
    },

    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        this.part_details();
    }
}
</script>